module.exports = __webpack_public_path__ + "img/gmsyt6.92a5c400.png";